import React, { FC, useMemo, useState, useEffect } from 'react'

import cx from 'classnames'

import { Collapse, List, ListItem, Link, Box } from '@material-ui/core'
import { ListItemProps } from '@material-ui/core/ListItem'
import ExpandLess from '@material-ui/icons/ExpandLess'
import ExpandMore from '@material-ui/icons/ExpandMore'

import CollapseItem from '~/components/shared/ListItem'
import { Title } from '~/components/shared/Text'

interface CollapseItemsProps {
  count: number
  items: any[]
  hideIcon?: boolean
  renderItem?: (item: any) => JSX.Element
  listItemProps?: Omit<ListItemProps, 'button'>
  onClick?: (open: boolean) => void
  fontSecondary?: boolean
  linkId?: string
  enteredClass?: string
}

const CollapseItems: FC<CollapseItemsProps> = ({
  items = [],
  count,
  hideIcon,
  children,
  renderItem,
  listItemProps,
  onClick,
  fontSecondary,
  linkId,
  enteredClass = 'c-entered'
}) => {
  const [seeAll, setSeeAll] = useState(false)

  useEffect(() => {
    setSeeAll(false)
  }, [items])

  const itemsAll = useMemo(() => {
    if (items) {
      const _reviews = [...items]
      return {
        preview: _reviews.splice(0, count),
        other: _reviews
      }
    }

    return {}
  }, [items, count])

  const handleClick = () => {
    onClick && onClick(!seeAll)
    setSeeAll((val) => !val)
  }

  const showTitle = typeof children === 'function' ? children(seeAll) : children

  return (
    <>
      <List
        dense
        style={{ padding: 0 }}
        className={cx({ [enteredClass]: seeAll })}
      >
        {itemsAll.preview?.map((item, index) => {
          if (renderItem) return renderItem(item)

          return (
            <CollapseItem listItemProps={listItemProps} key={index} {...item} />
          )
        })}
        <Collapse in={seeAll}>
          {itemsAll.other?.map((item, index) => {
            if (renderItem) return renderItem(item)

            return (
              <CollapseItem
                listItemProps={listItemProps}
                key={index}
                {...item}
              />
            )
          })}
        </Collapse>
        {count < items.length && (
          <ListItem dense disableGutters {...listItemProps}>
            <Link
              id={linkId}
              component="button"
              variant="body2"
              color="textPrimary"
              underline="none"
              onClick={handleClick}
            >
              <Box component="span" display="inline-flex" alignItems="center">
                <Box component="span">
                  <Title
                    fontSize={14}
                    fontWeight={400}
                    variant="h5"
                    fontFamily={
                      fontSecondary
                        ? 'Nunito Sans, sans-serif'
                        : 'Prompt, sans-serif'
                    }
                  >
                    {showTitle || 'Show'}
                  </Title>
                </Box>
                {!hideIcon && seeAll ? <ExpandLess /> : <ExpandMore />}
              </Box>
            </Link>
          </ListItem>
        )}
      </List>
    </>
  )
}

export default CollapseItems
